<template>
  <vue-modal :ref="modalName" :name="modalName" :scrollable="true" :width="875" :height="'auto'" :minHeight="700" :maxHeight="800">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title suggestions-popup-header">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        
        <div class="form-group suggestions-data-container">
          <!-- <road-map-initiative-display
            :moat-name="moatName"
            :moat-description="moatDescription"
          /> -->
          <div class="col-12 form-inline pl-0 pb-2">
            <div class="col-2 pr-0">
              <div class="d-flex justify-content-left flex-wrap leftLabel"></div>
            </div>
            
            <div class="col-10 pl-0">
              <div class="d-flex align-items-center flex-nowrap">
                <div class="labelData mr-3">
                  <div class="leftLabel text-nowrap">Period</div>
                </div>
                <div class="mr-4">
                  <label class="pl-1 mb-0 text-nowrap">{{ periodName }}</label>
                </div>

                <div class="labelData ml-5 mr-3">
                  <div class="leftLabel text-nowrap">Financial Metrics</div>
                </div>
                <div class="mr-4">
                  <label class="pl-1 mb-0 text-nowrap">{{ metricGroupName }}</label>
                </div>

                <div class="labelData ml-5 mr-3">
                  <div class="leftLabel text-nowrap">Metric Relationship</div>
                </div>
                <div class="mr-4">
                  <label class="pl-1 mb-0 text-nowrap">{{ metricRelationship }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2" v-if="showCustomInitiative">
            <div class="col-2 pr-0">
              <div class="d-flex justify-content-left flex-wrap leftLabel">Summary</div>
              <div class="d-flex justify-content-left flex-wrap">(1 to 2 sentences)</div>
            </div>
            <div class="col-10 pl-0">
              <div class="d-flex justify-content-left flex-wrap labelData">
                <textarea ref="initiativeText" v-model="selectedInitiative.initiative" id="initiativeText" :name="customInitiativeText" class="form-control w-100 selected-initiative" rows="2" :maxlength="260"></textarea>
              </div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2" v-if="showCustomInitiative">
            <div class="col-2 pr-0">
              <div class="d-flex justify-content-left flex-wrap leftLabel">The Action</div>
              <div class="d-flex justify-content-left flex-wrap">(Max 5000 chars)</div>
            </div>
            <div class="col-10 pl-0">
               <div id="initiativeDescriptionSection" class="d-flex justify-content-left flex-wrap labelData">
                 <textarea ref="initiativeDescription" v-model="selectedInitiative.description" id="initiativeDescription" :name="customInitiativeText+'_description'" class="form-control w-100 selected-initiative" rows="3" :maxlength="5000"></textarea>
                 <small class="text-muted">{{ selectedInitiative.description ? selectedInitiative.description.length : 0 }} of 5000</small>
               </div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2 pt-2">
            <div class="col-2 pr-0">
              <div class="d-flex justify-content-left flex-wrap leftLabel"></div>
            </div>
            
            <div class="col-10 pl-0">
              <div class="d-flex align-items-center flex-nowrap">
                <div class="labelData mr-3">
                  <div class="leftLabel text-nowrap">Show Suggestions From</div>
                </div>

                <div class="d-flex align-items-center flex-nowrap ml-3 mr-4">
                  <input
                    type="radio"
                    id="toolset1"
                    name="suggestionSource"
                    v-model="suggestionSource"
                    value="ai"
                    :disabled="!hasSelectedAiType()"
                    class="m-0"
                  />
                  <label for="toolset1" class="pl-2 mb-0 text-nowrap">{{ aiType.displayName || 'No AI Selected' }}</label>
                </div>

                <div class="d-flex align-items-center flex-nowrap ml-4">
                  <input
                    type="radio"
                    id="toolset2"
                    name="suggestionSource"
                    v-model="suggestionSource"
                    value="surveyGroup"
                    class="m-0"
                    :disabled="surveyName == ''"
                  />
                  <label for="toolset2" class="pl-2 mb-0 text-nowrap">{{ surveyName  || 'No Group Selected'}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 form-inline pl-0 pb-2">
            
            <div class="col-2 pr-0">
              <div class="d-flex justify-content-left flex-wrap leftLabel mr-4">
                <button type="button" class="btn btn-primary w-100" @click="copySuggestion">Copy</button>
                <div class="w-100 text-left mt-3">Select item,<br/>then copy</div>
              </div>
            </div>
            <div class="col-10 pl-0">
              <div v-if="suggestionSource == 'surveyGroup'" class="road-map-initiatives-table-container w-100" @scroll="handleInitiativeTableScroll">
                <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
                  <colgroup>
                    <col class="radio-button-column" />
                    <col />
                    <col />
                    <col v-if="showMetricGrowthColumn" />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="suggestions-header radio-button" style="width: 2rem !important"></th>
                      <th class="suggestions-header" style="width: 25rem !important">Summary</th>
                      <th class="suggestions-header" style="width: 7rem !important">Source</th>
                      <th class="suggestions-header" style="width: 5rem !important">Period of<br/>Initiative</th>
                      <th v-if="showMetricGrowthColumn" class="suggestions-header text-center" style="width: 7rem !important">{{ metricGroupName }} Growth</th>
                      <th class="suggestions-header text-center" style="width: 7rem !important">{{ metricRelationship }} Growth</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="table.data.length == 0">
                      <td :colspan="showMetricGrowthColumn ? 6 : 5" class="text-center">No results found</td>
                    </tr>
                    <tr v-for="initiativeRow in table.data" :key="initiativeRow.valueRoadMapInitiativeId">
                      <td class="text-center radio-button">
                        <input
                          v-show="displayInitiatives || showCustomInitiative"
                          v-model="selectedInitiativeId"
                          type="radio"
                          name="initiativeRadio"
                          :value="initiativeRow.valueRoadMapInitiativeId"
                          class="select-radio suggestions-popup-radio"
                          @change="selectInitiativeSuggestion(initiativeRow, initiativeRow.valueRoadMapInitiativeId)"
                        />
                      </td>
                      <td class="text-left">{{ initiativeRow.initiative }}</td>
                      <td class="text-left">{{ initiativeRow.surveyName }}</td>
                      <td class="text-left">{{ initiativeRow.clientTimePeriod.displayName }}</td>
                      <td v-if="showMetricGrowthColumn" class="text-center">
                        {{ initiativeRow.metricGrowth === '' || initiativeRow.metricGrowth == null
                          ? '--'
                          : initiativeRow.metricGrowth + '%'
                        }}
                      </td>
                      <td class="text-center">
                        {{ initiativeRow.metricGrowthRelationship === '' || initiativeRow.metricGrowthRelationship == null
                          ? '--'
                          : initiativeRow.metricGrowthRelationship + '%'
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="road-map-initiatives-table-container w-100" @scroll="handleInitiativeTableScroll">
                <table :id="table.id + '-ai'" :class="[table.class, 'road-map-ai-initiatives-table']" cellspacing="0" width="100%">
                  <colgroup>
                    <col class="radio-button-column" />
                    <col />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="suggestions-header radio-button"></th>
                      <th class="suggestions-header">Summary</th>
                      <th class="suggestions-header">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="isAiSuggestionsProcessing">
                      <td colspan="3" class="text-center">
                        <span class="spinner-border spinner-border-sm"></span>
                      </td>
                    </tr>
                    <tr v-else-if="aiTable.data.length == 0">
                      <td colspan="3" class="text-center">No suggestions found</td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(initiativeRow, idxAiInitiative) in aiTable.data"
                        :key="'ai-' + (initiativeRow.id || initiativeRow.aiRoadmapSuggestionId || idxAiInitiative)"
                        @click="selectInitiativeSuggestion(initiativeRow, getSuggestionId(initiativeRow, idxAiInitiative))"
                      >
                        <td class="text-left align-top radio-button">
                          <input
                            v-show="displayInitiatives || showCustomInitiative"
                            v-model="selectedInitiativeId"
                            type="radio"
                            name="initiativeRadio"
                            :value="getSuggestionId(initiativeRow, idxAiInitiative)"
                            class="select-radio suggestions-popup-radio"
                            @change="selectInitiativeSuggestion(initiativeRow, getSuggestionId(initiativeRow, idxAiInitiative))"
                          />
                        </td>
                        <td class="text-left align-top pr-2">
                          <div>{{ getSuggestionSummary(initiativeRow) }}</div>
                          <!-- <div v-if="aiType.vendor" class="ai-suggestion-powered-by">* Powered by {{ aiType.vendor }}</div> -->
                        </td>
                        <td class="text-left align-top pr-2">
                          <div>{{ getSuggestionAction(initiativeRow) }}</div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="artificial-intelligence-tools">
          <span class="modal-ai-advisory-note"></span>
        </div>
        <div class="suggestions-popup-buttons float-right mr-2">
          <button v-show="displayInitiatives" type="button" class="btn btn-primary mr-4" @click="addInitiative">{{ addOrSaveInitiative }}</button>
          <button type="button" class="btn btn-primary float-right ml-2 mr-2" @click="closeModal()">Close</button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AlertService from "../services/alert.service";
import ValueGroupMap from "../services/chart/value.group.map.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import GlobalMixins from "../mixins/GlobalMixins";
import ClientTimePeriodService from "../services/client.time.period.service";
import SurveyService from "../services/survey.service";
import AIService from "../services/ai.service";
import UserService from "../services/user.service";

import Swal from 'sweetalert2';
import AdminService from "../services/admin.service";

import MetricsService from "../services/metrics.service.js";
import aiService from "../services/ai.service";
import SurveyGroupService from "../services/survey.group.service";
import ValueGroupMapService from "../services/chart/value.group.map.service";

export default {
  name: "RoadmapInitiativesModal",
  mixins: [ViewMixins, GlobalMixins],
  components: {},
  methods: {
    addInitiative() {
      if (this.selectedInitiative) {
          if (this.saveEnabled){
            const initiativeContext = this.getInitiativeContext();
            let valueRoadMapInitiatives = [];
            valueRoadMapInitiatives.push({
              initiative: this.selectedInitiative.initiative,
              needNumber: this.needNumber,
              sequenceNumber: this.sequenceNumber,
              needType: this.needType,
              description: this.selectedInitiative.description,
              valueRoadMapId: this.initiativeValueRoadMapId
            });

            return ValueGroupMap.saveValueRoadMapInitiative(this.surveyCode, valueRoadMapInitiatives, this.initiativeValueRoadMapId, (response) => {
                let statusCode = response.data.statusCode;
                if (statusCode == 200) {
                  AdminService.displaySuccessMessage({ text: "Initiative saved successfully." });
                  this.closeModal(true);
                  return this.refreshSavedInitiative(initiativeContext);
                } else {
                  AdminService.displayErrorMessage({ text: response.data.message });
                }
            }, this);
          } else {
            this.$emit('add-initiative', this.selectedInitiative, this.needName);
          }
          this.closeModal();
      } else {
        AlertService.error("Please select an initiative to add.");
      }
    },
    getInitiativeContext() {
      return {
        surveyCode: this.surveyCode,
        needNumber: this.needNumber,
        needType: this.needType,
        valueRoadMapId: this.initiativeValueRoadMapId
      };
    },
    refreshSavedInitiative(context = this.getInitiativeContext()) {
      const key = JSON.stringify(context);
      if (!context.valueRoadMapId || !context.needNumber || !context.surveyCode || !context.needType
          || key !== JSON.stringify(this.getInitiativeContext())) return;
      const loadId = ++this.initiativeLoadId;
      return ValueGroupMap.getValueRoadMapInitiative(
        context.surveyCode, context.needNumber, context.needType, context.valueRoadMapId,
        response => {
          // A response for a closed modal or a different need must not replace its selection.
          if (loadId !== this.initiativeLoadId || key !== JSON.stringify(this.getInitiativeContext())) return;
          if (response.data.statusCode != 200) {
            AdminService.displayErrorMessage({ text: response.data.message });
            return;
          }
          const initiative = response.data.data || {};
          this.selectedInitiative = {
            initiative: initiative.initiative || "",
            description: initiative.description || ""
          };
        }, this
      );
    },
    closeModal(refreshInitiative = false) {
      this.initiativeLoadId++;
      const modal = this.$refs[this.modalName];
      if (modal != null) {
        // vue-js-modal 2.0.1 can attempt to unobserve the modal after its
        // element has already been removed, which aborts the close transition.
        // Disconnect first, then hide the instance and release its scroll lock.
        if (modal.resizeObserver != null) {
          modal.resizeObserver.disconnect();
        }
        modal.visibility.modal = false;
        modal.visibility.overlay = false;
        modal.visible = false;
      }
      document.body.classList.remove("vm--block-scroll");
      if (refreshInitiative) {
        this.$emit('refresh-initiative',this.selectedInitiative.initiative, this.selectedInitiative.description);
      }
      this.selectedInitiative = {};
    },
    loadData() {
      this.initiativeLoadId++;
      this.selectedInitiativeId = "";
      this.selectedInitiative = {};
      this.selectedSuggestion = {};
      
      this.loadRoadmapInitiativesBySurveyGroup();
      // this.table.data = this.moatInitiatives.slice().sort((a, b) => a.initiativeSequenceNumber - b.initiativeSequenceNumber);
      // this.table.data = this.moatInitiatives;
      this.resetAiSuggestions();
      if (this.suggestionSource == "ai") {
        this.loadAiSuggestions();
      }
      return this.refreshSavedInitiative();
    },
    resetAiSuggestions() {
      this.aiSuggestions = [];
      this.aiTable.data = [];
      this.aiSuggestionsLoaded = false;
      this.processInitiated = false;
      this.processingComplete = true;
      this.aiSuggestionsRequestKey = "";
    },
    getAiSuggestionsRequestKey() {
      return [
        this.needName || "",
        this.needNumber || 0,
        this.needType || "",
        this.clientTimePeriodId || "",
        this.metricGroupId || "",
        this.valueProfileClientChartId || ""
      ].join("|");
    },
    hasSelectedAiType() {
      return !!(this.aiType && this.aiType.aiTypeId);
    },
    loadAiSuggestions() {
      if (!this.hasSelectedAiType()) {
        this.resetAiSuggestions();
        return;
      }
      //this.aiSuggestionsLoaded = true;
      this.retrieveRoadmapInitiatives();
      
    },
    retrieveRoadmapInitiatives: function() {
      if (!this.hasSelectedAiType()) {
        this.resetAiSuggestions();
        return;
      }
      const requestKey = this.getAiSuggestionsRequestKey();
      this.aiSuggestionsRequestKey = requestKey;
      this.aiSuggestionsLoaded = false;
      this.processingComplete = false;
      this.processInitiated = true;
      this.$root.processServerRequest("Retrieving Roadmap Initiatives");

      let params = new URLSearchParams();
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("client_time_period_id", this.clientTimePeriodId);
      // params.append("metric_id", this.metricGroupId || 0);
      params.append("metric_id", 0);
      params.append("value_profile_client_chart_id", this.valueProfileClientChartId || 0);
      params.append("roadmap_ai_type_id", this.aiType.aiTypeId || 0);
      params.append("number_of_respondents", this.noOfRespondents);
      params.append("need_number", this.needNumber || 0);
      params.append("need_type", this.needType || "");
      params.append("need_name", this.needName || "");
      
      aiService.retrieveRoadmapInitiativesByAI(params, response => {
        this.retrieveRoadmapInitiativesCallback(response, requestKey);
      });
    },  
    retrieveRoadmapInitiativesCallback(response, requestKey) {
      if (requestKey != this.aiSuggestionsRequestKey) {
        return;
      }
      const data = response.data || {};
      let statusCode = data.statusCode;

      this.aiSuggestionsLoaded = false;
      if (statusCode == 200) {

        let aiSuggestionsList = data.data || [];
        let suggestionsRequired = this.numberOfSuggestions == 0 ? 5 : this.numberOfSuggestions;
        if(aiSuggestionsList.length < suggestionsRequired) {
          // generate more suggestions
          this.generateRoadmapInitiatives(aiSuggestionsList, suggestionsRequired - aiSuggestionsList.length, requestKey);
        } else if (aiSuggestionsList.length == suggestionsRequired) {
          this.aiSuggestions = aiSuggestionsList;
          this.aiTable.data = this.aiSuggestions;
          this.aiSuggestionsLoaded = true; 
          this.$root.processServerResponse();
          this.processInitiated = false;
          this.processingComplete = true;
        } else {
          this.aiSuggestions = aiSuggestionsList.slice(0, suggestionsRequired);
          this.aiTable.data = this.aiSuggestions;
          this.aiSuggestionsLoaded = true;
          this.$root.processServerResponse();
          this.processInitiated = false;
          this.processingComplete = true;
        }
        
      }

    },
    generateRoadmapInitiatives: function(existingSuggestionsList, noOfSuggestionsRequired, requestKey = this.getAiSuggestionsRequestKey()){
      if (!this.hasSelectedAiType()) {
        this.resetAiSuggestions();
        return;
      }
      this.processingComplete = false;
      this.processInitiated = true;
      this.$root.processServerRequest("Generating Roadmap Initiatives");

      let params = new URLSearchParams();
      params.append("client_id", this.clientObject.clientId);
      params.append("survey_id", SurveyService.getSurveyId());
      params.append("user_id", UserService.getUserId());
      params.append("client_time_period_id", this.clientTimePeriodId);
      params.append("number_of_suggestions", noOfSuggestionsRequired);
      // params.append("metric_id", this.metricGroupId);
      params.append("metric_id", 0);
      params.append("value_profile_client_chart_id", this.valueProfileClientChartId);
      params.append("roadmap_ai_type_id", this.aiType.aiTypeId);
      params.append("need_number", this.needNumber);
      params.append("need_type", this.needType);
      params.append("need_name", this.needName);
      params.append("number_of_respondents", 0);
      const roadmapChartData = this.buildRoadmapInitiativesChartData(this.needName);
      params.append("roadmap_chart_data", JSON.stringify(roadmapChartData));

      aiService.generateRoadmapInitiativesByAI(params, response => {
        this.generateRoadmapInitiativesCallback(response, existingSuggestionsList, requestKey);
      });
    },  
    generateRoadmapInitiativesCallback(response, existingSuggestionsList = [], requestKey) {
      if (requestKey != this.aiSuggestionsRequestKey) {
        return;
      }
      const data = response.data || {};
      let statusCode = data.statusCode;
      if (statusCode == 200) {
        const response_ai_type_id = (data.data?.ai_type) ? (data.data?.ai_type.aiTypeId) : 0;
        const selected_ai_type_id = this.aiType?.aiTypeId || 0;
        if(response_ai_type_id && selected_ai_type_id && response_ai_type_id != selected_ai_type_id) {
          AdminService.displayInfoMessage({ text: this.AUTO_SWITCH_LLM_MESSAGE}, { duration: 8000 }); // can be appended with - data?.ai_type.displayName 
        }
        if (response_ai_type_id) {
          this.aiType.aiTypeId = response_ai_type_id;
        }
        //this.saveToCard();
        const aiResults = data.data?.initiatives ? (data.data.initiatives) : [];
        const generatedSuggestions = this.getAiResultSuggestions(aiResults);
        this.aiSuggestions = existingSuggestionsList.concat(generatedSuggestions);
        this.aiTable.data = this.aiSuggestions;
        this.aiSuggestionsLoaded = true;
        // this.$nextTick(() => {
        //     this.initResultTables(finalData);
        // });
      } else {
        AdminService.displayErrorMessage({ text: response.message });
      }
      this.$root.processServerResponse();
      this.processInitiated = false;
      this.processingComplete = true;
    },
    selectInitiativeSuggestion(initiativeRow, initiativeId) {
      this.selectedSuggestion = JSON.parse(JSON.stringify(initiativeRow));
      this.selectedInitiativeId = initiativeId;
    },
    copySuggestion() {
      if (!this.selectedSuggestion || Object.keys(this.selectedSuggestion).length == 0) {
        AlertService.error("Please select an initiative to copy.");
        return;
      }
      const selectedInitiative = JSON.parse(JSON.stringify(this.selectedSuggestion));
      selectedInitiative.initiative = this.getSuggestionSummary(this.selectedSuggestion);
      selectedInitiative.description = this.getSuggestionAction(this.selectedSuggestion);
      this.selectedInitiative = selectedInitiative;
    },
    getSuggestionSummary(initiativeRow) {
      return initiativeRow.suggestion || initiativeRow.summary || initiativeRow.summaryRecommendation || initiativeRow.initiative || "";
    },
    getSuggestionAction(initiativeRow) {
      return initiativeRow.action || initiativeRow.description || "";
    },
    getAiResultSuggestions(aiResults) {
      if (Array.isArray(aiResults)) {
        return aiResults.reduce((suggestions, result) => {
          return suggestions.concat(result?.suggestions || result || []);
        }, []);
      }
      return aiResults?.suggestions || [];
    },
    getSuggestionId(initiativeRow, index) {
      return initiativeRow.id || initiativeRow.aiRoadmapSuggestionId || initiativeRow.moatInitiativeId || index;
    },
    getInitiativeAttribute(initiativeRow, attributeName) {
      try {
        const attributes = typeof initiativeRow.attributes === "string"
          ? JSON.parse(initiativeRow.attributes || "{}")
          : (initiativeRow.attributes || {});
        return attributes[attributeName] || "";
      } catch (e) {
        return "";
      }
    },
    handleInitiativeTableScroll(event) {
      if (!this.isInsiderUser) {
        return;
      }
      event.target.scrollTop = 0;
      if (this.insiderAlertShown) {
        return;
      }
      this.insiderAlertShown = true;
      Swal.fire({
        title: "",
        html: '<h5 class="text-center">You need to activate your full subscription to see all Initiative Ideas.</h5>',
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: false,
        footer: "",
        allowOutsideClick: true
      });
      setTimeout(() => {
        this.insiderAlertShown = false;
      }, 100);
    },
    readChartCriteriaParams() {
      if (typeof this.clientChartObject != "undefined") {
        let clientChart = JSON.parse(JSON.stringify(this.clientChartObject));
        // this.period = clientChart.clientTimePeriodId;
        ClientTimePeriodService.getClientTimePeriodsBySurveyCode(this.surveyCode, this.getClientTimePeriodsBySurveyCodeCallback, this);
        if (typeof this.clientChartObject.criteria != "undefined" && this.clientChartObject.criteria != "") {
          let params = new URLSearchParams(this.clientChartObject.criteria);
          // read metric group id
          let inputMetricGroupId = params.get("metric") || "";
          if (inputMetricGroupId != "") {
            if (inputMetricGroupId.includes("growth")) {
              this.useMetricGrowth = true;
              this.metricGroupId = inputMetricGroupId.replace("-growth", "");
            } else {
              this.metricGroupId = inputMetricGroupId;
              this.useMetricGrowth = false;
            }
            MetricsService.getMetricGroup(this.metricGroupId, "", this.getMetricGroupCallback, this);
          }
          // read ai_type
          let aiTypeId = params.get("roadmap_ai_type_id") || "";
          if (aiTypeId != "") {
            AIService.getAiType(aiTypeId, aiType => {
              this.aiType = aiType || {};
            });
          }
          // read client time period id
          this.clientTimePeriodId = params.get("period") || "";
          
          // read value_profile_client_chart_id
          this.valueProfileClientChartId = params.get("value_profile_client_chart_id") || "";
          
          // read number_of_suggestions
          this.numberOfSuggestions = params.get("number_of_suggestions") || 0;
          
        }
      }
    },
    getPeriodName(value) {
      if (this.client_time_periods.length > 0) {
        let period = this.client_time_periods.find(x => x.clientTimePeriodId == value);
        if (typeof period != "undefined") {
          return period.displayName;
        }
      }
      return "";
    },
    getMetricGroupCallback: function(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        // this.metricGroup.metricGroupId = response.data.data.metricGroup.metricGroupId;
        this.metricGroupName = response.data.data.metricGroup.name;
        if(this.useMetricGrowth) {
          this.metricGroupName = this.metricGroupName + " Growth";
        }
      }
    },
    getClientTimePeriodsBySurveyCodeCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.client_time_periods = response.data.data.clientTimePeriods;
      }
      this.periodName = this.getPeriodName(this.clientChartObject.clientTimePeriodId)
    },
    buildRoadmapInitiativesChartData(needName) {
      const data = this.roadmapChartData || {};

      if (!Array.isArray(data.cols) || !Array.isArray(data.rows)) {
        return {
          cols: [],
          rows: [],
          isPositiveCorrelation: data.isPositiveCorrelation,
          emotionalNeedNamesMap: data.emotionalNeedNamesMap,
          companyName: data.companyName
        };
      }

      const selectedCols = this.getSelectedColumnsForRecommendations(data) || [];
      const colIndexes = this.getColumnIndexes(data, selectedCols);
      const filteredRows = this.getFilteredRows(data, colIndexes, needName);
            
      return {
        cols: selectedCols,
        rows: filteredRows,
        isPositiveCorrelation: data.isPositiveCorrelation,
        emotionalNeedNamesMap: data.emotionalNeedNamesMap,
        companyName: data.companyName
      };
    },
    getSelectedColumnsForRecommendations(data) {
      if (!data?.cols) return;
      const selectedCols = [];
      data.cols.forEach(col => {

        if (col.id === "need") {
            selectedCols.push({ ...col });
        }
        if (this.includeValueGaps === "Y" && col.id === "gap") {
            selectedCols.push({ ...col });
        }
        if (this.includeExpectations === "Y" && col.id === "customer-expectations") {
            selectedCols.push({ ...col });
        }
        if (this.includePerformance === "Y" && col.id === "performance") {
            selectedCols.push({
                ...col,
                label: data.companyName
            });
        }
        if (this.includeWillingnessToPay === "Y" && col.id === "pricing-power") {
            selectedCols.push({
                ...col,
                label: SurveyService.getWTPLabel()
            });
        }
        if (this.includeRelativeStrength === "Y" && col.id === "relative-strength") {
            selectedCols.push({ ...col });
        }
        if (col.id === "nps") {
            selectedCols.push({ ...col });
        }
      });
      return selectedCols;
    },
    getColumnIndexes(data, selectedCols) {
      return selectedCols.map(sc =>
          data.cols.findIndex(c => c.id === sc.id)
      );
    },
    getFilteredRows(data, colIndexes, needName) {
    const needLookup = {};
    (data.emotionalNeedNamesMap || []).forEach(n => {
        needLookup[n.needName] = n.dimensionName;
    });

    return data.rows
      .filter(row => {
          const needColIndex = data.cols.findIndex(col => col.id === "need");
          const needValue = row.c[needColIndex] ? row.c[needColIndex].v : '';
          return needValue === needName;
      })
      .map(row => {
        return colIndexes.map(i => {
            const cell = row.c[i];
            let value = cell ? cell.v : '';
            const colId = data.cols[i].id;

            if (colId === "pricing-power" && value !== '') {
                value = value + "%";
            } else if (colId === "need" && value !== '') {
                value = needLookup[value] || value;
            } else {
                value = this.formatRecommendationValue(value);
            }

            return value;
        });
      });
    },
    formatRecommendationValue(value) {
      const numericValue = parseFloat(value);
      if (typeof numericValue === 'number' && !isNaN(numericValue)) {
          return numericValue.toFixed(2);
      }
      return value;
    },
    async getSurveyGroupName() {
      if (!this.initiativesSurveyGroupId) {
        this.surveyName = ""; //SurveyService.getSurveyName();
        return;
      }

      const surveyGroupId = Number(this.initiativesSurveyGroupId);
      SurveyGroupService.getSurveyGroup(
        surveyGroupId,
        "",
        response => {
          if (surveyGroupId != Number(this.initiativesSurveyGroupId)) {
            return;
          }
          if (response.data.statusCode == 200) {
            this.surveyName = response.data.data.surveyGroupName || "";
          }
        },
        this
      );
          
    },
    loadRoadmapInitiativesBySurveyGroup() {
      if (!this.initiativesSurveyGroupId) {
        this.surveyName = "";
        this.moatInitiatives = [];
        this.table.data = [];
        return [];
      }
      this.getSurveyGroupName();
      ValueGroupMapService.getRoadmapInitiativesBySurveyGroupId(this.initiativesSurveyGroupId, this.needNumber, this.needType, Number(this.metricGroupId) || 0, Number(this.metricGroupRelationshipId) || 0, this.getRoadmapInitiativesBySurveyGroupIdCallback, this);
    },
    getRoadmapInitiativesBySurveyGroupIdCallback(response) {
      this.sectorIdList = [];
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        // de-duplicate initiatives
        const seenInitiatives = new Set();
        this.moatInitiatives = (Array.isArray(response.data.data) ? response.data.data : []).filter(initiative => {
          const initiativeValue = initiative.initiative;
          if (seenInitiatives.has(initiativeValue)) return false;
          seenInitiatives.add(initiativeValue);
          return true;
        });
        this.table.data = this.moatInitiatives;
        //MoatService.getMoatInitiativeDataList(this.getMoatInitiativeDataListCallback, this);
      } else if (statusCode == 201) {
        // AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
  },
  props: {
    inputValueRoadMapId: {
      type: Number,
      default: null
    },
    modalName: {
      type: String,
      default: "road-map-initiatives"
    },
    clientChartObject: {
      type: Object,
      default: function() {
        return {
          clientChartId: 0
        };
      }
    },
    roadmapChartData: {
      type: Object,
      default: () => ({})
    },
    initiativesSurveyGroupId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      title: "Roadmap Initiatives",
      needName: "",
      needNumber: 0,
      sequenceNumber: 0,
      needType: "",
      valueRoadMapId: 0,
      initiativeLoadId: 0,
      moatDescription: {
        description: "",
        attributes: "{}"
      },
      moatInitiatives: [],
      moatName: "",
      selectedInitiative: {},
      selectedSuggestion: {},
      initiative: "",
      selectedInitiativeId: "",
      initiatives: [],
      features: "",
      displayInitiatives: true,
      showCustomInitiative: false,
      addOrSaveInitiative: "Add Initiative",
      saveEnabled: false,
      insiderAlertShown: false,
      AUTO_SWITCH_LLM_MESSAGE: "Due to high demand, selected AI toolset could not complete your request. One or more results are generated using an alternate AI model.",
      element: Object,
      table: {
        id: `road-map-initiatives-table-${this.modalName}`,
        data: [],
        class: "table display wrap row-border table-hover p-0",
      },
      aiTable: {
        id: `road-map-ai-initiatives-table-${this.modalName}`,
        data: [],
        class: "table display wrap row-border table-hover p-0",
      },
      aiSuggestionsLoaded: false,
      aiSuggestionsRequestKey: "",
      successLevelLabel: "Success Opportunity",
      salesIncreaseLabel: "Potential <br/> Sales Lift",
      costReductionLabel: "Potential <br/> Cost Savings",
      customInitiativeText: "",
      periodName: "",
      metricGroupId: "",
      metricGroupName: "--",
      useMetricGrowth: false,
      client_time_periods: [],
      metricRelationship: "",
      aiType: {},
      suggestionSource: "ai",
      clientTimePeriodId: "",
      valueProfileClientChartId: "",
      numberOfSuggestions: 0,
      aiSuggestions: [],
      includeValueGaps: "Y",
      includeExpectations: "Y",
      includePerformance: "Y",
      includeWillingnessToPay: "Y",
      includeRelativeStrength: "N",
      processingComplete: true,
      processInitiated: false,
      showResults: false,
      surveyName: "",
      survey_id_list: [],
    };
  },
  computed: {
    initiativeValueRoadMapId() {
      return this.inputValueRoadMapId == null ? this.valueRoadMapId : this.inputValueRoadMapId;
    },
    isAiSuggestionsProcessing() {
      return this.suggestionSource == "ai" && this.processInitiated && !this.processingComplete;
    },
    showMetricGrowthColumn() {
      return typeof this.metricGroupName == "string" && !(this.metricGroupName.trim() == "" || this.metricGroupName.trim() == "--");
    },
    moatFeatures() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.attributes) {
        let moatAttributes = JSON.parse(this.moatDescription.attributes);
        return moatAttributes?.features || "";
      }
      return "";
    },
    initiativeEmotion() {
      if (typeof this.moatDescription != "undefined" && this.moatDescription != null && this.moatDescription.features) {
        let moatAttributes = JSON.parse(this.moatDescription.features);
        return moatAttributes?.features || "";
      }
      return "";
    },
    noOfRespondents: function() {
        return this.recommendationsData?.noOfRespondents || 0;
    },
  },
  mounted() {
    this.suggestionSource = "ai";
    //this.loadSurveyGroupData();
  },
  watch: {
    suggestionSource(newVal) {
      if (newVal == "ai") {
        this.loadAiSuggestions();
      }
    },
    clientChartObject: {
      handler() {
        this.readChartCriteriaParams();
      },
      deep: true,
      immediate: true
    },
    initiativesSurveyGroupId() {
      this.loadRoadmapInitiativesBySurveyGroup();
    },
  },
};
</script>

